import { CookiesServicesService } from './cookies-services.service';
import { ApiLinks } from '../data/apiLinks';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  userId: any;
  constructor(
    private _apilink: ApiLinks,
    private http: HttpClient,
    private cookiesServicesService: CookiesServicesService
  ) {}

  getHeaders() {
    // let authtoken: any = localStorage.getItem('authtoken');
    let token =
      'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJyb2FtYnVkZHkiLCJpc01lcmNoYW50Ijp0cnVlLCJpYXQiOjE2NDQzMDg4NTJ9.fqQGcYkRGNwlu3irRC62_RfQgrMBf44_Q5f0jnCooNOGXsBh5i0tLBglRxRnxMb7oaOxrbqUlalLuQetL9-B0A';
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', token);
    return headers;
  }

  editAgent(data: { status: string }, id: number) {
    const headers = this.getAuthToken();
    return this.http.put(this._apilink.editAgent + id, data, { headers });
  }

  getAuthToken() {
    // let authtoken: any = localStorage.getItem('admin_token');
    let auth_token: any = this.cookiesServicesService.getCookie('auth_token');
    this.userId = this.cookiesServicesService.getCookie('userId');
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', auth_token);
    return headers;
  }

  getAccessToken() {
    // let authtoken: any = localStorage.getItem('admin_token');
    let accesstoken: any =
      this.cookiesServicesService.getCookie('access_token');
    this.userId = this.cookiesServicesService.getCookie('userId');
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', accesstoken);
    return headers;
  }

  getAuthTokenWithNoContType() {
    let authtoken: any = this.cookiesServicesService.getCookie('admin_token');
    const headers = new HttpHeaders().set('Authorization', authtoken);
    return headers;
  }

  // use
  userLogin(data: any) {
    // let headers = this.getHeaders();
    return this.http.post(this._apilink.wl_login, data);
  }

  // use
  listDataPlan() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.getAllPlansOFWL, { headers });
  }

  // use
  getAllAssignPlansOfWL(config) {
    // config.page -= 1;
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.getAllAssignPlans +
        'pagination?page=' +
        config.page +
        '&pageSize=' +
        config.pageSize +
        '&searchStr=' +
        config.searchStr,
      { headers }
    );
  }

  createPlan(data: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.createPlan, data, { headers });
  }

  uploadPricing(data: any) {
    let headers = this.getAuthToken();
    return this.http.put(this._apilink.uploadPricing, data, { headers });
  }

  updatePlan(data: any) {
    let headers = this.getAuthToken();
    return this.http.put(this._apilink.updatePlan, data, { headers });
  }

  // use
  getPlanById(id: any) {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.getPlanById + id, { headers });
  }

  removeWLPlan(id: any) {
    let headers = this.getAuthToken();
    return this.http.delete(this._apilink.deletePlanById + id, { headers });
  }

  // use
  getAllCouponsWithPagination(config) {
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.getAllCoupons +
        '/pagination?page=' +
        config.page +
        '&pageSize=' +
        config.pageSize +
        '&searchStr=' +
        config.searchStr,
      { headers }
    );
  }

  createCoupons(data: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.createCoupon, data, { headers });
  }

  removeCoupon(id: any) {
    let headers = this.getAuthToken();
    return this.http.delete(this._apilink.deleteCoupon + id, { headers });
  }

  getAllWLESIMOrdersWithPagination(config) {
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.wlEsimOrdersList +
        '/pagination?page=' +
        config.page +
        '&pageSize=' +
        config.pageSize +
        '&searchStr=' +
        config.searchStr,
      { headers }
    );
  }

  getAllWLESIMOrders() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.wlEsimOrdersList, { headers });
  }

  getAllWLTopupOrdersWithPagination(config) {
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.wlRechargeOrdersList +
        '/pagination?page=' +
        config.page +
        '&pageSize=' +
        config.pageSize +
        '&searchStr=' +
        config.searchStr,
      { headers }
    );
  }

  getAllWLTopupOrders() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.wlRechargeOrdersList, { headers });
  }

  // getAllWLCustomersWithPagination(config) {
  //   let headers = this.getAuthToken();
  //   return this.http.get(
  //     this._apilink.allCustomers +
  //     '/pagination?page=' +
  //     config.page +
  //     '&pageSize=' +
  //     config.pageSize +
  //     '&searchStr=' +
  //     config.searchStr +
  //     `&type=${config?.type}`,
  //     { headers }
  //   );
  // }

  getAllWLCustomersWithPagination(config: any = null) {
    let headers = this.getAccessToken();
    let url = this._apilink.allCustomers;
    if (config && config !== null) {
      url =
        url +
        '?page=' +
        config?.page +
        '&pageSize=' +
        config?.pageSize +
        '&type=' +
        config?.type +
        '&searchStr=' +
        (config?.searchStr ? config?.searchStr : null);
    }
    return this.http.get(url, { headers: headers });
  }

  // getAllWLAgentsWithPagination(config) {
  //   let headers = this.getAuthToken();
  //   return this.http.get(
  //     this._apilink.allAgents +
  //       '/pagination?page=' +
  //       config.page +
  //       '&pageSize=' +
  //       config.pageSize +
  //       '&searchStr=' +
  //       config.searchStr,
  //     { headers }
  //   );
  // }

  addCustomerBalance(id: number, data: any) {
    let headers = this.getAuthToken();
    console.log({ id });
    // return id;
    return this.http.put(this._apilink.addBalance + `${id}/add-balance`, data, {
      headers,
    });
  }

  deductCustomerBalance(id: number, data: any) {
    let headers = this.getAuthToken();
    console.log({ id });
    // return id;
    return this.http.put(
      this._apilink.deductBalance + `${id}/deduct-balance`,
      data,
      { headers }
    );
  }

  getCustomerWalletHistoryById(id: number) {
    let headers = this.getAuthToken();
    console.log({ id });
    // return id;
    return this.http.get(this._apilink.walletHistoryById + `${id}/all`, {
      headers,
    });
  }

  getCustomerOrderHistory(id: any) {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.customerOrderHistoryById + id, {
      headers,
    });
  }

  getWalletHistory(config: any) {
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.walletHistory +
        '?page=' +
        config?.page +
        '&pageSize=' +
        config?.pageSize +
        '&searchStr=' +
        config?.searchStr,
      {
        headers,
      }
    );
  }

  addFaq(data: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.addFaq, data, { headers });
  }

  updateFaq(data: any) {
    let headers = this.getAuthToken();
    return this.http.put(this._apilink.updateFaq, data, { headers });
  }

  removeFaq(id: any) {
    let headers = this.getAuthToken();
    return this.http.delete(this._apilink.deleteFaq + 'delete/' + id, {
      headers,
    });
  }

  getAllFaq() {
    let headers = this.getHeaders();
    return this.http.get(this._apilink.allFaq, { headers });
  }

  getAllFaqWithPagination(config) {
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.allFaq +
        '/pagination?page=' +
        config.page +
        '&pageSize=' +
        config.pageSize +
        '&searchStr=' +
        config.searchStr,
      { headers }
    );
  }

  getallUserContacts() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.contactDetail + '/all', { headers });
  }

  getallPartnerContacts() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.contactDetail + '/affiliate/all', {
      headers,
    });
  }

  getallResellerContacts() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.contactDetail + '/reseller/all', {
      headers,
    });
  }

  allWLPlanSync() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.planSync, { headers });
  }

  getEmailSetup() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.emailSetup, { headers });
  }

  emailSetup(payload: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.emailSetup + '/setup', payload, {
      headers,
    });
  }

  updateGeneralSettings(id: number, data: any) {
    let headers = this.getAuthToken();
    return this.http.put(this._apilink.updateGeneralSettings + id, data, {
      headers,
    });
  }

  generalSettings() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.generalSettings, {
      headers,
    });
  }

  changePassword(data: any) {
    let headers = this.getAccessToken();
    return this.http.post(this._apilink.changePass, data, { headers });
  }

  // userVerification(email: any) {
  //   let headers = this.getAccessToken();
  //   return this.http.get(this._apilink.verifyUser + email);
  // }

  requestOtpForPasswordReset(username: string) {
    return this.http.post(this._apilink.requestOtpForPasswordReset, {
      username,
    });
  }

  // forgetPassword(data: any) {
  //   let headers = this.getAccessToken();
  //   return this.http.post(this._apilink.forgetPass, data);
  // }

  verifyOtpAndResetPassword(data: any) {
    return this.http.post(this._apilink.verifyOtpAndResetPassword, data);
  }

  addMobileDevice(data: any) {
    let headers = this.getAccessToken();
    return this.http.post(this._apilink.createMobileDevice, data, { headers });
  }

  getAllMobileDevice() {
    let headers = this.getAccessToken();
    return this.http.get(this._apilink.allMobileDevice, { headers });
  }

  getWalletDetails() {
    return this.http.get(this._apilink.walletDetails);
  }

  purchaseEsimPlans(payload: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.purchaseEsim, payload, {
      headers: headers,
    });
  }

  initiateRefundEsim(body: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.initiateRefund, body, { headers });
  }

  refundRequestEsim(body: any) {
    let headers = this.getAuthToken();
    return this.http.post(this._apilink.refundRequest, body, { headers });
  }

  approveRefundRequestEsim(id: number) {
    let headers = this.getAuthToken();
    return this.http.put(
      this._apilink.approveRefundRequest + id,
      {},
      {
        headers,
      }
    );
  }

  getRefundList() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.refundList, { headers });
  }

  getRefundRequestList(config: any) {
    let headers = this.getAuthToken();
    return this.http.get(
      this._apilink.refundRequestList +
        '?page=' +
        config?.page +
        '&pageSize=' +
        config?.pageSize +
        '&searchStr=' +
        config?.searchStr,
      { headers }
    );
  }

  getAccountingReport() {
    let headers = this.getAuthToken();
    return this.http.get(this._apilink.accountingReport, { headers });
  }

  getEsimDetails(query: string) {
    let headers = this.getAccessToken();
    return this.http.get(this._apilink.esimDetails + '?' + query, {
      headers: headers,
    });
  }

  getAllIccIds() {
    let headers = this.getAccessToken();
    return this.http.get(this._apilink.alleSimList, { headers });
  }

  getCountriesByIccid(iccid: any, planType: any) {
    let headers = this.getAccessToken();
    return this.http.get(
      this._apilink.rechargeEsimCountryByIccid +
        '?iccid=' +
        iccid +
        '&type=' +
        planType,
      { headers }
    );
  }

  getDataByCountryIccid(iccid: any, type: any, ccode: any) {
    let headers = this.getAccessToken();
    return this.http.get(
      this._apilink.rechargeEsimDataByCountryIccid +
        '?iccid=' +
        iccid +
        '&type=' +
        type +
        '&name=' +
        ccode,
      { headers }
    );
  }

  getRechargePackages(iccid: any, data: any, ccode: any, planType: any) {
    let headers = this.getAccessToken();
    return this.http.get(
      this._apilink.rechargeEsimPackages +
        '?iccid=' +
        iccid +
        '&data=' +
        data +
        '&name=' +
        ccode +
        '&type=' +
        planType,
      { headers }
    );
  }

  getRechargePackagesWithout8943(iccid: any) {
    let headers = this.getAccessToken();
    return this.http.get(
      this._apilink.rechargeEsimPackageswithout8943 + '/' + iccid,
      { headers }
    );
  }

  rechargeEsimData(payload: any) {
    let headers = this.getAccessToken();
    return this.http.post(this._apilink.rechargeEsimByAdmin, payload, {
      headers,
    });
  }

  customerDetailsByIccid(iccid: any) {
    let headers = this.getAccessToken();
    return this.http.get(this._apilink.customerDetailsByIccid + iccid, {
      headers,
    });
  }

  validateSim(iccid: any) {
    let headers = this.getAccessToken();
    return this.http.get(this._apilink.validateSim + iccid, { headers });
  }

  activateSim(data: any) {
    let headers = this.getAccessToken();
    return this.http.post(this._apilink.activateSim, data, { headers });
  }

  getAllModules() {
    let headers = this.getAccessToken();
    return this.http.get(this._apilink.allModules, { headers: headers });
  }

  createRoles(data: { name: string; description: string; permissions: any[] }) {
    const headers = this.getAccessToken();
    return this.http.post(this._apilink.createRoles, data, { headers });
  }

  // getRoles() {
  //   let headers = this.getAccessToken();
  //   return this.http.get(this._apilink.roles, { headers: headers });
  // }

  getRoles(config: any = null) {
    let headers = this.getAccessToken();
    let url = this._apilink.roles;
    if (config && config !== null) {
      url =
        url +
        '?page=' +
        config?.page +
        '&pageSize=' +
        config?.pageSize +
        '&searchStr=' +
        config?.searchStr;
    }
    return this.http.get(url, { headers: headers });
  }

  getRolePermissions(roleId: number) {
    const headers = this.getAccessToken();
    return this.http.get(this._apilink.rolesPermissions + `?roleId=${roleId}`, {
      headers,
    });
  }

  getRoleById(roleId: number) {
    const headers = this.getAccessToken();
    return this.http.get(this._apilink.getRoleById + `${roleId}`, {
      headers,
    });
  }

  updateRoles(id: number, data: any) {
    let headers = this.getAuthToken();
    return this.http.put(this._apilink.updateRoles + id, data, { headers });
  }

  createUser(data: { username: string; email: string; roleId: number }) {
    const headers = this.getAuthToken();
    return this.http.post(this._apilink.createUser, data, { headers });
  }

  createAgent(data: { firstname: string; email: string; lastname: string }) {
    const headers = this.getAuthToken();
    return this.http.post(this._apilink.createAgent, data, { headers });
  }

  getUsers(config: any) {
    let headers = this.getAccessToken();
    let url = this._apilink.allUsers;
    if (config && config !== null) {
      url =
        url +
        '?page=' +
        config?.page +
        '&pageSize=' +
        config?.pageSize +
        '&searchStr=' +
        config?.searchStr;
    }
    return this.http.get(url, { headers: headers });
  }

  updateUser(id: number, data: any) {
    let headers = this.getAuthToken();
    return this.http.put(this._apilink.updateUsers + id, data, { headers });
  }

  deleteUser(id: number) {
    let headers = this.getAuthToken();
    return this.http.delete(this._apilink.deleteUser + id, { headers });
  }
}
